import React from 'react';
import styled, { keyframes } from 'styled-components';
import ameni from "../assets/Pictuefwfre.png";

const fadeInUp = keyframes`
  from { opacity: 0; transform: translateY(20px); }
  to { opacity: 1; transform: translateY(0); }
`;

export const PageContainer = styled.div`
  width: 100%;
  padding: 20px;
  background-color: #0c0c00db;

  @media (max-width: 480px) {
    width: 100%;
  }
`;

export const ContentSection = styled.section`
  display: flex;
  justify-content: center;
  align-items: flex-start;
  gap: 40px;
  position: relative;
  text-align: left;
  margin-top: 30px;

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 20px;
  }
`;

export const ImageContainer = styled.div`
  position: relative;
  flex: 1;
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 10px;
  }

  @media (max-width: 768px) {
    max-width: 90%;
  }
`;

export const Overlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 10px;
  opacity: 0;
  transition: opacity 0.3s ease;

  &:hover {
    opacity: 1;
  }

  p {
    color: #fff;
    font-size: 1.5rem;
    animation: ${fadeInUp} 0.5s ease;
  }
`;

export const TextContainer = styled.div`
  flex: 1;
  h1 {
    font-size: 2.5rem;
    margin-bottom: 20px;
    color: #ffffff;
    animation: ${fadeInUp} 0.7s ease;
  }

  p {
    font-size: 1.5rem;
    margin-bottom: 20px;
    line-height: 1.6;
    color: #fff;
    animation: ${fadeInUp} 0.9s ease;
  }

  .learn-more {
    padding: 10px 20px;
    background: #f39c12;
    color: white;
    border: none;
    border-radius: 5px;
    cursor: pointer;
    font-size: 1.5rem;
    transition: background-color 0.3s ease;

    &:hover {
      background: #e67e22;
    }
  }

  .additional-content {
    margin-top: 30px;
    font-size: 1.6rem;
    color: #fff;
    line-height: 1.6;
  }

  .amenities-list {
    display: flex;
    flex-wrap: wrap;
    gap: 20px;
    padding-left: 0;
  }

  .amenities-list li {
    width: calc(33.33% - 20px); 
    margin-bottom: 10px;
    list-style-type: square;
  }

  @media (max-width: 768px) {
    .amenities-list li {
      width: 100%; 
    }
  }
`;

export const LogosContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 30px;
  justify-content: center;
  margin-bottom: 50px;

  .logo-wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 10px;
    padding: 10px;
  }

  .logo-wrapper img {
    height: 80px;
    object-fit: contain;
    transition: transform 0.3s ease, filter 0.3s ease;
    filter: grayscale(100%) contrast(100%) brightness(0) invert(1);
  }

  .logo-wrapper img:hover {
    filter: grayscale(0) contrast(1) brightness(1) invert(0);
    transform: scale(1.1);
  }

  .logo-wrapper .logo-heading {
    font-size: 1rem;
    color: #ffffff;
    text-align: center;
    font-weight: bold;
    text-transform: uppercase;
  }
`;

const Amenities = () => {
  return (
    <PageContainer id="amenities">
      <div style={{ textAlign: 'center', marginBottom: '50px', color: "#ffffff" }}>
        <h1><strong>AMENITIES</strong></h1>
        <div style={{
          width: '5%', 
          height: '5px', 
          background: 'linear-gradient(to right, #5ca9fb 0%, #6372ff 100%)', 
          margin: '0 auto', 
          animation: 'animateDivider 2s ease-in-out'
        }}></div>
      </div>

      <LogosContainer>
        <div className="logo-wrapper">
          <img src="https://inthatquietearth-totalenvironment.in/wp-content/uploads/2024/10/bicycle.png" alt="Cycling Track" />
          <div className="logo-heading">Cycling Track</div>
        </div>
        <div className="logo-wrapper">
          <img src="https://inthatquietearth-totalenvironment.in/wp-content/uploads/2024/10/Dog2.png" alt="Dog Park" />
          <div className="logo-heading">Dog Park</div>
        </div>
        <div className="logo-wrapper">
          <img src="https://inthatquietearth-totalenvironment.in/wp-content/uploads/2024/10/Jogging-2.png" alt="Jogging Track" />
          <div className="logo-heading">Jogging Track</div>
        </div>
        <div className="logo-wrapper">
          <img src="https://inthatquietearth-totalenvironment.in/wp-content/uploads/2024/10/eucalyptus-2.png" alt="Eucalyptus Grove" />
          <div className="logo-heading">Eucalyptus Grove</div>
        </div>
        <div className="logo-wrapper">
          <img src="https://inthatquietearth-totalenvironment.in/wp-content/uploads/2024/10/playground-2.png" alt="Kid's Play Area" />
          <div className="logo-heading">Kid's play area</div>
        </div>
        <div className="logo-wrapper">
          <img src="https://inthatquietearth-totalenvironment.in/wp-content/uploads/2024/10/Yoga-2.png" alt="Yoga / Meditation" />
          <div className="logo-heading">Meditation / yoga /<br /> seating deck</div>
        </div>
        <div className="logo-wrapper">
          <img src="https://inthatquietearth-totalenvironment.in/wp-content/uploads/2024/10/Ground-3.png" alt="Open Playground" />
          <div className="logo-heading">Open playground</div>
        </div>
        <div className="logo-wrapper">
          <img src="https://inthatquietearth-totalenvironment.in/wp-content/uploads/2024/10/Relex.png" alt="Reflexology Path" />
          <div className="logo-heading">Reflexology path</div>
        </div>
        {/* <div className="logo-wrapper">
          <img src="https://inthatquietearth-totalenvironment.in/wp-content/uploads/2024/10/amphitheatre-3.png" alt="Amphitheatre" />
          <div className="logo-heading">Stepped seats / Amphitheatre</div>
        </div> */}
      </LogosContainer>

      <ContentSection>
        <ImageContainer>
          <img src={ameni} alt="Amenities" />
          <Overlay>
            <p>Exclusive Amenities for Your Comfort</p>
          </Overlay>
        </ImageContainer>
        <TextContainer>
          <h1>Discover Our Amenities</h1>
          <p>
            Our facilities are designed to provide you with the utmost comfort and convenience.
            From luxurious spaces to cutting-edge services, explore what we have to offer.
          </p>
          <a href='#footer'>
            <button className="learn-more">Learn More</button>
          </a>
          <div className="additional-content">
            <h2 style={{color:"#ffffff"}}>Our Key Amenities:</h2>
            <ul className="amenities-list">
              <li>Cycling Track</li>
              <li>Dog Park</li>
              <li>Jogging Track</li>
              <li>Eucalyptus Grove</li>
              <li>Kid's Play Area</li>
              <li>Meditation / Yoga Deck</li>
              <li>Open Playground</li>
              <li>Reflexology Path</li>
              <li>Amphitheatre</li>
            </ul>
          </div>
        </TextContainer>
      </ContentSection>
    </PageContainer>
  );
};

export default Amenities;
